import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/services/app/app.service';

@Injectable({
  providedIn: 'root'
})
export class UrlBasedGuardGuard implements CanActivate {
  constructor(private appService: AppService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      if (!this.appService.getData('training-portal.userInfo')) {
        // this.appService.logOut()
       return  false
      }
      let userType=JSON.parse(this.appService.getData('training-portal.userInfo'))["group_type"];
      const requiredPermissions: string[] =route.data?.['requiredPermissions'];
      if (!requiredPermissions || !requiredPermissions.includes(userType)) {
        // Logout if the user doesn't have the required permission
        // this.appService.logOut()
        return false
      }
    return true;
  }
  
}
